export default "__VITE_ASSET__$AAxdZyx__"